"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onSelectedCrewOn = exports.onLeave = exports.crewUpdate = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var stringUtils_sidecar_1 = require("@lib/stringUtils-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var diveCrew_hero_sidecar_1 = require("@voyage/crew/diveCrew_hero-sidecar");
var voyageGameStatus_sidecar_1 = require("@voyage/game-status/voyageGameStatus-sidecar");
var voyageSystems_sidecar_1 = require("@voyage/systems/voyageSystems-sidecar");
var voyageUiSubsystem_sidecar_1 = require("@voyage/ui/voyageUiSubsystem-sidecar");
function crewUpdate(obj) {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    var d = obj.heroState;
    assert_sidecar_1.assert.notNil(d);
    // voyageGameStatus.get().hasReactorRunning.willBeActive = true
    var useSystemTime = 3;
    d.useSystemTimer += ds;
    diveCrew_hero_sidecar_1.diveCrew_hero.setProgress(obj, d.useSystemTimer / useSystemTime);
    if (d.useSystemTimer > useSystemTime) {
        d.useSystemTimer -= useSystemTime;
        if (voyageSystems_sidecar_1.voyageSystems.testNoPower(obj)) {
            return;
        }
        var status_1 = voyageGameStatus_sidecar_1.voyageGameStatus.get();
        diveCrew_sidecar_1.diveCrew.say(obj, 'Jump drive charged to ' +
            stringUtils_sidecar_1.stringUtils.formatInteger(status_1.jumpCharge) +
            '%');
        status_1.addJumpCharge += 15.0; // TODO: based on ship?
    }
}
exports.crewUpdate = crewUpdate;
function onLeave(obj) {
    voyageUiSubsystem_sidecar_1.voyageUiSubsystem.setOpen(false);
}
exports.onLeave = onLeave;
function onSelectedCrewOn(obj) {
    // voyageUiSubsystem.setOpen(true, obj.tile)
}
exports.onSelectedCrewOn = onSelectedCrewOn;
